/* src/tutors/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import TutorCard from './cards/TutorCard';
import TutorListCard from './cards/TutorListCard';

class Tutors extends React.Component {
  constructor(props) {
    super(props);
    this._random = 'hi';
  }


  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.root} spacing={16}>
        <Grid item xs={12} md={6}>
          <TutorListCard innerRef={node => this.list = node} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TutorCard fetchTutors={() => this.list.getWrappedInstance()._onFetchTutors()} /> {/* eslint-disable-line */}
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  root: {
    flexGrow: 1,
  },
  card: {
    height: 800,
    overflowY: 'auto',
  },
});

Tutors.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Tutors);



// WEBPACK FOOTER //
// ./src/modules/tutors/Scene.js